
export default (function (ref) {
  return ref ? ref.ownerDocument.defaultView : window;
});


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/view/get-window-from-ref.js
// module id = 462
// module chunks = 1